import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PopularPacks from './PopularPacks'
import TopLabels from './TopLabels'
import MyItemsSidebar from './MyItemsSidebar'
import PopularCollections from './PopularCollections'

import {
  withRouter,
  Router,
  Switch,
  Route,
} from "react-router-dom";

@inject('sidebarStore')
@inject('labelStore')
@observer
class Sidebar extends Component {
  componentDidMount() {
    console.debug("Sidebar#componentDidMount")
    this.props.sidebarStore.fetch()
  }

  get onHomePage() {
    const { history } = this.props
    return history.location.pathname === "/"
  }

  render() {
    const { sidebarStore, labelStore, history } = this.props

    return (
      <div className='ml-8 mt-9 min-w-[370px] max-w-[370px] hidden min-[1350px]:block flex flex-col pr-12'>
        <Router history={history}>
          <Switch>
            <Route path="/label/:id" exact>
              <PopularPacks products={labelStore.bestsellers} title="Popular Releases" />
            </Route>
            <Route>
              { !this.onHomePage && history.location.pathname !== "/all_products/popularPacks" &&
                <PopularPacks products={sidebarStore.packs}  title="Popular Packs" /> }
              <TopLabels firstInSidebar={this.onHomePage} />
              <MyItemsSidebar />
              <PopularCollections />
            </Route>
          </Switch>
        </Router>
      </div>
    )
  }
}

export default withRouter(Sidebar)
